var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__speach"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25__x28_Stroke_x29_",
    d: "M8,8.802h24v17.567h-7.479L20,31.198l-4.521-4.829H8V8.802z  M10.667,11.469v12.233h5.97L20,27.296l3.364-3.594h5.969V11.469H10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4447",
    d: "M14.223,16.803h2.666v2.666h-2.666V16.803z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4448",
    d: "M18.667,16.803h2.666v2.666h-2.666V16.803z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4449",
    d: "M23.111,16.803h2.666v2.666h-2.666V16.803z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.1cf84ae3b6f75cfae65e7c8913c16801.svg";
export { ForwardRef as ReactComponent };